const GetNotificationSettingsUrl = `/admin/api/notification_settings`;
const UpdateNotificationSettingsUrl = (id: number) => `/admin/api/notification_settings/${id}`;

export { GetNotificationSettingsUrl, UpdateNotificationSettingsUrl };